/// <amd-module name="Repos/Views/Settings/ProjectBranchPolicies/Components/AddProjectBranchPoliciesPanel" />
import * as React from "react";
import * as Resources from "Repos/Views/Settings/ProjectBranchPolicies/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { VssComponent } from "VSS/Platform/Layout";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";
import { TitleSize } from "VSSUI/Header";
import { Observer } from "VSSUI/Observer";
import { Panel } from "VSSUI/Panel";
import { RadioButton, RadioButtonGroup } from "VSSUI/RadioButton";
import { IProjectBranchPoliciesService } from "../Contracts";
import { BranchPatternSelector } from "./BranchPatternSelector";

export interface IAddProjectBranchPoliciesPanelProps {
    projectBranchPoliciesService: IProjectBranchPoliciesService;
    onDismiss: () => void;
    setSelectedRefs: (value: string) => void;
}

export class AddProjectBranchPoliciesPanel extends VssComponent<IAddProjectBranchPoliciesPanelProps> {
    private readonly scopeTypePattern = new ObservableValue<boolean>(false);
    private readonly branchPattern = new ObservableValue<string>("");
    private readonly isValidPattern = new ObservableValue<boolean>(false);

    public render(): JSX.Element {
        const { projectBranchPoliciesService, onDismiss } = this.props;

        const { scopeTypePattern, branchPattern, isValidPattern } = this;

        return (
            <Observer {...{ scopeTypePattern, branchPattern, isValidPattern }}>
                {() => (
                    <Panel
                        contentClassName="flex-column"
                        lightDismiss={true}
                        titleProps={{
                            text: Resources.AddProjectPolicy,
                            size: TitleSize.Large
                        }}
                        footerButtonProps={[
                            {
                                text: Resources.Cancel,
                                onClick: onDismiss
                            },
                            {
                                text: Resources.Create,
                                primary: true,
                                disabled: scopeTypePattern.value && !isValidPattern.value,
                                onClick: () => {
                                    this.props.setSelectedRefs(this.getRefName(scopeTypePattern.value, branchPattern.value));
                                }
                            }
                        ]}
                        onDismiss={onDismiss}
                    >
                        <div className="flex-column v-scroll-auto h-scroll-hidden rhythm-vertical-8">
                            <RadioButtonGroup
                                onSelect={selectedId => {
                                    scopeTypePattern.value = selectedId == "pattern";
                                }}
                                selectedButtonId={scopeTypePattern.value ? "pattern" : "default"}
                                text={Resources.BranchesToProtect}
                            >
                                <RadioButton id="default" text={Resources.RadioDefault} />
                                <RadioButton id="pattern" text={Resources.RadioPattern} />
                            </RadioButtonGroup>

                            <ConditionalChildren renderChildren={scopeTypePattern.value}>
                                <BranchPatternSelector {...{ projectBranchPoliciesService, branchPattern, isValidPattern }} />
                            </ConditionalChildren>
                        </div>
                    </Panel>
                )}
            </Observer>
        );
    }

    private getRefName(scopeTypePattern: boolean, branchPattern: string): string {
        if (scopeTypePattern) {
            return "refs/heads/" + branchPattern;
        } else {
            return "~default";
        }
    }
}
